<template>
  <div class="addRom">
    <el-form :model="romForm" :rules="romRules" ref="romForm" class="demo-romForm" label-position="left">

      <!-- 基础信息 -->
      <div class="form-section">
        <div class="sec-title">基础信息</div>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="rom图标" prop="romIcon">
              <upload-img :fixedNumber="[690, 256]" fixedName="690:256" accept="image/*" tip="" uploadName="上传图标"
                @uploadInfo="uploadInfo" :fixedFlag="false" fileDir="rom_icon" :resultImg="romForm.romIcon" />
            </el-form-item>
            <el-form-item label="图片链接">
              <el-input v-model="romForm.romIcon" placeholder="粘贴 http(s) 图片链接" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="form-actions">
              <el-button @click="resetForm('romForm')" class="cancel-btn calloff-btn">取消</el-button>
              <el-button type="primary" @click="submitForm('romForm')" class="enter-btn save-btn"
                :loading="submitLoading">保存</el-button>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="rom名字(中文)" prop="romName">
              <el-input v-model="romForm.romName" placeholder="请输入rom名字(中文)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="rom名字(英文)" prop="romNameEn">
              <el-input v-model="romForm.romNameEn" placeholder="请输入rom名字(英文)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="描述(中文)" prop="description">
            <el-input v-model="romForm.description" placeholder="请输入描述(中文)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="描述(英文)" prop="descriptionEn">
            <el-input v-model="romForm.descriptionEn" placeholder="请输入描述(英文)"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="rom类型" prop="romType">
            <el-select v-model="romForm.romType" placeholder="请选择rom类型" filterable>
              <el-option v-for="item in romTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="游戏类型" prop="romGameType">
            <el-select v-model="romForm.romGameType" placeholder="请选择游戏类型" filterable>
              <el-option v-for="item in romGameTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      </div>

      <!-- 下载配置 -->
      <div class="form-section">
        <div class="sec-title">下载配置</div>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="下载地址" prop="downloadLink">
            <el-input v-model="romForm.downloadLink" placeholder="请输入下载地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主文件" prop="mainFile">
            <el-input v-model="romForm.mainFile" placeholder="请输入主文件"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="2号下载地址" prop="downloadLink">
            <el-input v-model="romForm.twoDownloadLink" placeholder="请输入2号下载地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="标签">
            <div class="switch-row">
              <span class="sw-item">热门<el-switch v-model="romForm.isHot" :active-value="1"
                  :inactive-value="0" /></span>
              <span class="sw-item">推荐<el-switch v-model="romForm.isRecommend" :active-value="1"
                  :inactive-value="0" /></span>
              <span class="sw-item">双人<el-switch v-model="romForm.isDouble" :active-value="1"
                  :inactive-value="0" /></span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="文件大小" prop="fileSize">
            <el-input v-model="romForm.fileSize"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="云文件路径" prop="cloudFilePath">
            <el-input v-model="romForm.cloudFilePath" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      </div>

      <!-- 平台支持 -->
      <div class="form-section">
        <div class="sec-title">
          <span>平台支持</span>
          <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="addPlatformRow">新增平台</el-button>
        </div>
        <el-table :data="romForm.romPlatformList" border size="mini" max-height="240" class="platform-table">
          <el-table-column label="平台名字">
            <template slot-scope="scope">
              <el-select v-model="scope.row.romSupportedPlatform" placeholder="请选择支持平台" filterable>
                <el-option v-for="item in romSupportedPlatformList" :key="Number(item.value)" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-select v-model="scope.row.status" placeholder="请选择状态" filterable>
                <el-option v-for="item in statusList" :key="Number(item.value)" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="核心名字">
            <template slot-scope="scope">
              <el-input v-model="scope.row.coreName" placeholder="请输入核心名字"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <div style="display:flex; gap: 6px; align-items: center; width:100%;">
                <el-input v-model="scope.row.notes" placeholder="选填" style="flex:1;"></el-input>
                <el-button size="mini" icon="el-icon-delete" style="z-index: 10;"
                  @click.stop="scope.row.notes = ''"></el-button>
              </div>
            </template>

          </el-table-column>
        </el-table>
      </div>
    </el-form>
  </div>
</template>

<script>
import UploadImg from "../../../components/UploadImg";
import { setRom, getRomDetail } from "@/api/simulator";
export default {
  components: { UploadImg },
  data() {
    return {
      romForm: {
        romIcon: "",
        romName: "",
        romNameEn: "",
        description: "",
        descriptionEn: "",
        romType: "",
        romGameType: "",
        downloadLink: "",
        twoDownloadLink: "",
        mainFile: "",
        romPlatformList: [],
        isHot: 0,
        isRecommend: 0,
        isDouble: 0,
      },
      romTypeList: [],
      romGameTypeList: [],
      romSupportedPlatformList: [],
      statusList: [],
      romRules: {
        romIcon: [
          { required: true, message: "请上传rom图标", trigger: "change" },
        ],

        romNameEn: [
          { required: true, message: "请输入名字(英文)", trigger: "blur" },
        ],

        description: [
          { required: true, message: "请输入描述(中文)", trigger: "blur" },
        ],

        descriptionEn: [
          { required: true, message: "请输入描述(英文)", trigger: "blur" },
        ],

        romType: [
          { required: true, message: "请选择rom类型", trigger: "change" },
        ],
        romGameType: [
          { required: true, message: "请选择游戏类型", trigger: "change" },
        ],
        downloadLink: [
          { required: true, message: "请输入下载地址", trigger: "blur" },
        ],
        twodownloadLink: [
          { required: true, message: "请输入2号下载地址", trigger: "blur" },
        ],
        mainFile: [
          { required: true, message: "请输入主文件", trigger: "blur" },
        ],
      },
      submitLoading: false,
      type: "add",
      // 来源列表页的查询条件，返回时原样带回
      backQuery: {},

      // 5秒自动保存定时器(注释则取消自动保存)
      // autoSaveTimer: null,
    };
  },
  created() {
    // 记下来源页的查询条件（含 page 和各个筛选字段），返回时原样带回
    const { type, id, ...rest } = this.$route.query;
    this.backQuery = rest;

    this.type = type;
    if (this.type === "edit") {
      const romId = id;
      // 校验id是否存在
      if (!romId) {
        this.$message.error("缺少数据ID，无法编辑");
        this.$router.go(-1);
        return;
      }
      // 调用详情接口获取完整数据
      this.fetchRomDetail(romId);
    }
  },
  mounted() {
    this.romTypeList = this.getDictDatas(this.DICT_TYPE.ROM_TYPE);
    this.romGameTypeList = this.getDictDatas(this.DICT_TYPE.ROM_GAME_TYPE);
    this.romSupportedPlatformList = this.getDictDatas(this.DICT_TYPE.ROM_SUPPORTED_PLATFORM);
    this.statusList = this.getDictDatas(this.DICT_TYPE.STATUS);

    // 每5秒自动检查一次(方法注释则取消自动保存)
    this.autoSaveTimer = setInterval(() => {
      this.autoSave();
    }, 20000);
  },
  methods: {
    // 上传rom图标
    uploadInfo(info) {
      this.romForm.romIcon = info;
    },

    // 5秒自动保存(方法注释则取消自动保存)
    autoSave() {
      // 正在保存，不重复保存
      if (this.submitLoading) {
        return;
      }

      // 图标为空，不保存
      if (!this.romForm.romIcon) {
        return;
      }

      // 游戏类型为 -1，不保存
      if (
        this.romForm.romGameType === -1 ||
        this.romForm.romGameType === "-1"
      ) {
        return;
      }

      console.log("满足自动保存条件，开始自动保存");

      // 调用原来的保存方法
      this.submitForm("romForm");
    },

    // 新建rom
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.submitLoading = true;
        try {
          if (this.type === "add") {
            await setRom({
              ...this.romForm,
            });
            // this.$message.success("添加成功");
            // this.$router.go(-1);
            this.$message.success("添加成功");
            this.backToList();
          } else {
            const {
              id,
              romIcon,
              romName,
              romNameEn,
              description,
              descriptionEn,
              romType,
              romGameType,
              downloadLink,
              twoDownloadLink,
              mainFile,
              romPlatformList,
              isHot,
              isRecommend,
              isDouble,
              // 冗余字段
              fileSize,
              cloudFilePath,
            } = this.romForm;
            const params = {
              id,
              romIcon,
              romName,
              romNameEn,
              description,
              descriptionEn,
              romType,
              romGameType,
              downloadLink,
              twoDownloadLink,
              mainFile,
              romPlatformList,
              isHot,
              isRecommend,
              isDouble,
              // 冗余字段
              fileSize,
              cloudFilePath,
            };
            await setRom(params);
            // this.$message.success("修改成功");
            // this.$router.go(-1);
            this.$message.success("修改成功");
            this.backToList();
          }
        } catch (err) {
          // 后端报错、网络异常都会进这里
          console.error("保存ROM失败", err);
          this.$message.error("操作失败，请稍后重试");
        } finally {
          // 无论成功/失败，最后都关闭loading
          this.submitLoading = false;
        }

      });
    },
    // 返回列表（带上来源筛选条件）
    backToList() {
      this.$router.push({
        path: "/romList",
        query: this.backQuery,
      });
    },
    resetForm() {
      this.backToList();
    },
    // 根据id查询详情回填表单
    async fetchRomDetail(id) {
      try {
        const res = await getRomDetail(id);
        const data = res.result;
        // 赋值表单
        this.romForm = {
          ...data,
          // 开关只认 1/0，后端可能返回 null
          isHot: Number(data.isHot) === 1 ? 1 : 0,
          isRecommend: Number(data.isRecommend) === 1 ? 1 : 0,
          isDouble: Number(data.isDouble) === 1 ? 1 : 0,
        };
      } catch (err) {
        console.log("获取ROM详情失败{}", err);
        this.$message.error("获取ROM详情失败");
        this.$router.go(-1);
      }
    },

    // 新增一行平台明细
    addPlatformRow() {
      this.romForm.romPlatformList.push({
        id: "",
        romId: "",
        romSupportedPlatform: "",
        status: "",
        coreName: "",
        notes: ""
      });
    },
  },
  // 离开页面时清除5秒自动保存(方法注释则取消自动保存)
  beforeDestroy() {
    if (this.autoSaveTimer) {
      clearInterval(this.autoSaveTimer);
      this.autoSaveTimer = null;
    }
  },
};

</script>
<style lang="scss" scoped>
.addRom {
  ::v-deep .demo-romForm {
    .el-form-item__label {
      white-space: nowrap;
      min-width: 100px;
      font-size: 13px;
      color: #595959;
    }

    // 只给表单里 非表格 的el-input设宽度350px
    .el-form-item:not(.el-table__cell .el-form-item) .el-input {
      width: 350px;
    }

    // 表单项间距压缩
    .el-form-item {
      margin-bottom: 14px;
    }

    // 分区容器
    .form-section {
      padding-bottom: 0;

      & + .form-section {
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px solid #f0f0f0;
      }
    }

    // 分区标题（左侧橙色竖条）
    .sec-title {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 0 14px;
      padding-left: 10px;
      font-size: 14px;
      font-weight: 500;
      color: #262626;
      line-height: 20px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 14px;
        border-radius: 2px;
        background: #ff5d2f;
      }
    }

    // 热门/推荐/双人 开关组
    .switch-row {
      display: flex;
      align-items: center;
      gap: 20px;
      height: 40px;

      .sw-item {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        color: #262626;
      }
    }

    // 平台表格
    .platform-table {
      th {
        background: #fafafa;
        font-weight: 500;
        color: #262626;
      }
    }

    // 表格内所有输入控件取消固定宽，自适应单元格
    .el-table__cell .el-input,
    .el-table__cell .el-select {
      width: 100% !important;
    }

    // 图标行右侧的操作按钮
    .form-actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;
      height: 100%;
      padding-right: 2px;

      .el-button {
        min-width: 88px;
        height: 36px;
        font-size: 13px;
      }

      .el-button + .el-button {
        margin-left: 0;
      }
    }

  }
}
</style>
